import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
    Layout: {
        'cart': 'Cart',
        'navList': ["Home", "Mall", "Exhibition", "News", "Contact Us"],
        'shopList': ['Event Mall', 'Full Price', 'Half Price'],
        'contactList': ['Join Us', 'Comment'],
        'logOut': 'Logout',
        'logIn': 'Login',
        'register': 'Register',
        'message': 'Messages',
        'myOrders': 'My Orders',
        'myFavor': 'Favorites',
        'currentLan': 'English',
        'cartGoods': 'goods',
        'cartGoodsTotal': 'Total',
        'cartPrice': 'Total Price',
        'buy': 'Buy',
        'cartEmpty': 'The cart is empty~',
        'messageEmpty':'Theres no messages for now~'
    },
    HomePage: {
        'titleList': ['Exhibition hall', 'Hot sale']
    },
    Shop: {
        'search': 'search',
        'fullPrice': 'Full Price',
        'halfPrice': 'Half Price',
        'scale': 'Scale',
        'status': 'Status',
        'scaleList': ["All", "1/1", "1/12", "1/18", "1/43", "1/64", "1/87"],
        // 'statusList': ["All", "Pre-sale", "Hot", "Replenishing", "Cut off", "Coming soon", "Sold out"],
        'statusList': [{ id: '', name: 'All' }, { id: '20', name: 'Pre-sale' }, { id: '10', name: 'Hot' }, { id: '30', name: 'Replenishing' }, { id: '40', name: 'Cut off' }, { id: '50', name: 'Coming soon' }, { id: '60', name: 'Sold out' }],
    },
    News: {
        'newsType': [{ id: '0', name: 'All' }, { id: '1', name: 'Brand' }, { id: '2', name: 'Products' }, { id: '3', name: 'Events' }],
        'checkDetails': 'Details',
        'pages': ['', 'Pages', 'News']
    },
    Contact: {
        'titleName': ['Join us', 'Leave a message', 'Contact information'],
        'button': 'Submit',
        'typeList': [{ id: '0', name: 'Advisory' }, { id: '1', name: 'Feedback' }, { id: '2', name: 'Suggestion' }],
        'placeholders': ['Last name', 'First name', 'Sex', 'Position title', 'Contact imformation', 'Your email', 'Quetion type', 'Content', 'Upload resume（Less than 2M）'],
        'social': [
            { imgUrl: "static/img/wem.png", name: "Facebook" },
            { imgUrl: "static/img/wem.png", name: "Wechat" },
            { imgUrl: "static/img/wem.png", name: "Weibo" },
            { imgUrl: "static/img/wem.png", name: "Wechat mall" }
        ],
        'info': [
            { name: "Telephone", val: "400-8818-792" },
            { name: "Fanpage", val: "www.facebook.com/kingartshk" },
            { name: "Weibo", val: "weibo.com/u/3906268664" },
            { name: "WeChat public", val: "KingArtsHK" },
            { name: "Email", val: "info@guanxingroup.com" },
            { name: "Website", val: "www.king-arts.com" },
            { name: "Address", val: "Unit1501,15/F.,Grand Millennium Plaza,181 Queen's Road Central,Hong Kong" }
        ]
    },
    Personal: {
        'optionList': ['Personal', 'Member', 'Password', 'My orders', 'Favourites', 'My cart'],
        'formTtile': ['Name', 'Sex', 'Phone', 'Email', 'Zip code', 'Operating', 'Saved shipping addrss', 'Receiver', 'Address', 'Edit', 'Delete', 'New address'],
        'dialogTitle': ['Modify information', 'New shipping address', 'Modify shipping address'],
        'del': 'Do you want to delete this address',
        'tips': ['Edit successfully', 'New address added', 'Deleted successfully', 'Edit successfully'],
        'sexList': [{ id: '0', name: 'Male' }, { id: '1', name: 'Female' }],
        'placeholders': ['Your name', 'Sex', 'Your phone', 'Your email', 'Receiver\'s name', 'Receiver\'s telephone', 'Continent', 'Country', 'Full address', 'Zip code']

    },
    Member: {
        'title': ['My level', 'Points rules and offers'],
        'levels': ['Bronze member', 'Silver member', 'Golden member', 'Diamond member'],
        'coupon': ['0%Off', '5%Off', '10%Off', '20%Off'],
        'diamond':['You have become ',', can have'],
        'note': ['Shopping', 'No consumption in one month'],
        'tables': ['Current level', 'Points', 'Discounts'],
        'hints': ['', ' Points to be ', ', will be able to have', '% Off'],
        'rule': 'Registed users will be Bronze members as defalut and have no discount for shopping. Every dollar spent will earn one point. When the total is up to 1000, users will become Silver member and have a 5% discount. When it goes to 5000, users will be Golden member with 10% discount. When its 10,000 users will be Diamon member with 20% discount. The point will be reduced by 500 if users didnt consume 30 days since last order.'
    },
    changePass: {
        'title': ['Old password', 'Password', 'Confirm again'],
        'placeholders': ['Please enter the old password', 'The format should be 8-20 letters and numbers', 'Enter the new password again'],
        'error': ['Please enter the password', 'Please enter the password in the correct format', 'Please enter the password again', 'Inconsistent input password twice!'],
        'tips': 'Change successfully',
    },
    favor: {
        'cancel': 'Delete',
        'tips': 'Deleted successfully',
        'dialog': ['Do you want to delete this collection?', 'Cancel', 'Confirm'],

    },
    cart: {
        'table': ['Info', 'Unit price', 'Amount', 'Discount', 'Total', 'Operating'],
        'dialog': ['Do you want to delete it?', 'Cancel', 'Confirm'],
        'oper': ['Favorite', 'Delete'],
        'bottom': ['', ' selected total（shipping not included）', 'Pay']
    },
    login: {
        'title': 'Login',
        'placeholders': ['Email account', 'Enter password'],
        'tips': 'Login successfully',
        'oper': ['Register', 'Forgot password ?']
    },
    regis: {
        'title': ['Account', 'Code', 'Password', 'Password', 'Registered?'],
        'oper': ['Get Code', 'Register', 'Check to agree', '<KingArts terms of service>'],
        'placeholders': 'Enter 4 letter code',
        'codetext': ['Get code', 'Sending...', 's Resend'],
        'tips': ['Registed successfully', 'Send successfully，please check'],
        'error': ['Please enter the email', 'Please enter the email in the correct format', 'Please enter the code', 'Please agree the terms of service']
    },
    pay: {
        'title': ['Choose your payment', 'Transaction number', 'Total', 'Payment', 'Pay now'],
        'hints': 'Please use your Wechat to pay'
    },
    recovery: {
        'title': ['Forgot password'],
        'tips':'Reset successfully'
    },
    orders: {
        'tabs': [{ id: '0', name: 'All' }, { id: '1', name: 'UnPaid' }, { id: '2', name: 'UnDelivered' }, { id: '3', name: 'UnReceived' }, { id: '4', name: 'UnCommented' }],
        // 'tabs': ['All', 'UnPaid', 'UnDelivered', 'UnReceived', 'UnCommented'],
        'time': 'Order time',
        'oper': ['View Logistics', 'Shipping', 'Pay', 'Cancel', 'Details']
    },
    logi: {
        'title': ['Shipping details', 'Shipment number', 'Company']
    },
    details: {
        'title': ['Amount', 'Details', 'Comments'],
        'oper': ['Share', 'Favorite', 'Buy now', 'Add to cart'],
        'list':['Front money','Pre-sale deadline','Please pay the tail before','','Inventory','Sold out']
    },
    checkorder: {
        'title': ['Order number', 'Order time', 'Details',],
        'innerTitle': ['Informations', 'Receiver', 'Contact', 'Address', 'Price', 'Shipping area', 'Shipping company', 'Freight', 'Total'],
        'oper': ['Cancel', 'Pay'],
        'label': ['Informations', 'Price', 'Amount', 'Coupon', 'Total', 'Deal price']
    },
    submitorder: {
        'title': ['Choose Address', 'Manage Address', 'Order information', 'Remarks', 'Confirm'],
        'hints': ['Tips', 'The order is up to', 'you could go to the half price mall', 'Sure', 'Whatever'],
        'half': ['Half price', 'Please select one of the half price items', 'Half price']
    },
    comment: {
        'title': 'Does it match the description?',
        'placeholders': 'Tell us about your feelings'
    },
    public: {
        "regisbtn":'Submit',
        'annouce': 'Annoucement',
        'more': 'More',
        'confirm': 'Confirm',
        'cancel': 'Cancel',
        'sex': ['male', 'female'],
        'prev': 'Prev',
        'next': 'Next',
        'loginstatus': 'Not logged in',
        'noitem':'your cart is empty~',
        'money':'CNY'
    },
    newword:{
        'new1':'Please select a product',
        'new2':'Successfully added to my favourites',
        'new3':'Successfully removed',
        'new4':'Successfully commented',
        'new5':'Successfully added to my cart',
        'new6':'Successfully canceled',
        'new7':'Received confirm',
        'new8':'Sure to cancel this order?',
        'new9':'Please enter the code',
        'new10':'Sure to delete this order?'
      }
}

export default en;


// WEBPACK FOOTER //
// ./src/i18n/langs/en.js